/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessServiceAvailability } from './BusinessServiceAvailability';
import {
    BusinessServiceAvailabilityFromJSON,
    BusinessServiceAvailabilityFromJSONTyped,
    BusinessServiceAvailabilityToJSON,
    BusinessServiceAvailabilityToJSONTyped,
} from './BusinessServiceAvailability';
import type { MenuItemSearchEssential } from './MenuItemSearchEssential';
import {
    MenuItemSearchEssentialFromJSON,
    MenuItemSearchEssentialFromJSONTyped,
    MenuItemSearchEssentialToJSON,
    MenuItemSearchEssentialToJSONTyped,
} from './MenuItemSearchEssential';

/**
 * 
 * @export
 * @interface MenuCategorySearchEssential
 */
export interface MenuCategorySearchEssential {
    /**
     * 
     * @type {string}
     * @memberof MenuCategorySearchEssential
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuCategorySearchEssential
     */
    name: string;
    /**
     * 
     * @type {Array<MenuCategorySearchEssential>}
     * @memberof MenuCategorySearchEssential
     */
    menuSubcategories?: Array<MenuCategorySearchEssential>;
    /**
     * 
     * @type {Array<MenuItemSearchEssential>}
     * @memberof MenuCategorySearchEssential
     */
    menuItems?: Array<MenuItemSearchEssential>;
    /**
     * 
     * @type {Array<BusinessServiceAvailability>}
     * @memberof MenuCategorySearchEssential
     */
    serviceAvailabilities?: Array<BusinessServiceAvailability>;
}

/**
 * Check if a given object implements the MenuCategorySearchEssential interface.
 */
export function instanceOfMenuCategorySearchEssential(value: object): value is MenuCategorySearchEssential {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MenuCategorySearchEssentialFromJSON(json: any): MenuCategorySearchEssential {
    return MenuCategorySearchEssentialFromJSONTyped(json, false);
}

export function MenuCategorySearchEssentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuCategorySearchEssential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'menuSubcategories': json['menuSubcategories'] == null ? undefined : ((json['menuSubcategories'] as Array<any>).map(MenuCategorySearchEssentialFromJSON)),
        'menuItems': json['menuItems'] == null ? undefined : ((json['menuItems'] as Array<any>).map(MenuItemSearchEssentialFromJSON)),
        'serviceAvailabilities': json['serviceAvailabilities'] == null ? undefined : ((json['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityFromJSON)),
    };
}

export function MenuCategorySearchEssentialToJSON(json: any): MenuCategorySearchEssential {
    return MenuCategorySearchEssentialToJSONTyped(json, false);
}

export function MenuCategorySearchEssentialToJSONTyped(value?: MenuCategorySearchEssential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'menuSubcategories': value['menuSubcategories'] == null ? undefined : ((value['menuSubcategories'] as Array<any>).map(MenuCategorySearchEssentialToJSON)),
        'menuItems': value['menuItems'] == null ? undefined : ((value['menuItems'] as Array<any>).map(MenuItemSearchEssentialToJSON)),
        'serviceAvailabilities': value['serviceAvailabilities'] == null ? undefined : ((value['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityToJSON)),
    };
}

